import anime from "animejs";




(function($) {
  var header = $(".header");

  $(".backplate").click(function() {
    $(".menu-tendina").removeClass("menu-tendina--active");
    $(".o-popup").removeClass("o-popup--open");
    $(".hamburger").removeClass("is-active");
    $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
    $(".btn-nav").removeClass("btn-nav--active");
    $(this).removeClass("backplate--open");
  });


  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    $(".backplate").toggleClass("backplate--open");
  });

  $(".menu-tendina__close").click(function() {
    $(".menu-tendina").removeClass("menu-tendina--active");
    $(".backplate").removeClass("backplate--open");
  });

  $(".header__cats__trigger").click(function() {
    $(".header__cats__menu").toggleClass("header__cats__menu--active");
    $(".header__cats__trigger").toggleClass("header__cats__trigger--active");
  });


  

  

  // $('.menu-item').hover(function() {
  //   var classes = $(this).attr('class').split(' ');
  //   var number = classes.filter(function(c) {
  //     return c.indexOf('menu-item-') === 0;
  //   })[0].match(/\d+/)[0];
  //   $('.menu-item').removeClass('menu-item--active');
  //   $('.menu-immagine').removeClass('menu-immagine--active');
  //   $(this).addClass('menu-item--active');
  //   $('.menu-immagine-' + number).addClass('menu-immagine--active');
  // });



  // $('.menu-item').hover(function() {
  //   var classes = $(this).attr('class').split(' ');
  //   var number = classes.filter(function(c) {
  //     return c.indexOf('menu-item-') === 0;
  //   })[0].match(/\d+/)[0];
  //   $('.menu-item').removeClass('menu-item--active');
  //   $('.menu-immagine').removeClass('menu-immagine--active');
  //   $(this).addClass('menu-item--active');
  //   $('.menu-immagine-' + number).addClass('menu-immagine--active');
  //   clearTimeout($(this).data('timeoutId'));
  // },
  // function() {
  //   var $this = $(this);
  //   var classes = $(this).attr('class').split(' ');
  //   var number = classes.filter(function(c) {
  //     return c.indexOf('menu-item-') === 0;
  //   })[0].match(/\d+/)[0];
  //   var $image = $('.menu-immagine-' + number);
  //   $this.data('timeoutId', setTimeout(function() {
  //     $this.removeClass('menu-item--active');
  //     $image.removeClass('menu-immagine--active');
  //   }, 100));
  // });


if ($(window).width() < 768) {

  var clicked = false;
  $('.menu-item').click(function() {
    if ($(this).hasClass("menu-item--active")) {
      console.log('riclick');
      // Gestisci il riclic qui
      var $this = $(this);
      var classes = $(this).attr('class').split(' ');
      var classNumber = classes.filter(function(c) {
        return c.indexOf('menu-item-') === 0;
      });
      if(classNumber.length > 0){
          var number = classNumber[0].match(/\d+/);
          if(number != null){
              number = number[0];
              var $image = $('.menu-immagine-' + number);
              $this.data('timeoutId', setTimeout(function() {
                $this.removeClass('menu-item--active');
                $image.removeClass('menu-immagine--active');
                $this.find('.menu-item__submenu').slideUp();
              }, 100));
          }
      }
    } else {
      // Gestisci il clic qui
      console.log('click');
      var classes = $(this).attr('class').split(' ');
      var classNumber = classes.filter(function(c) {
        return c.indexOf('menu-item-') === 0;
      });
      if(classNumber.length > 0){
          var number = classNumber[0].match(/\d+/);
          if(number != null){
              number = number[0];
              $('.menu-item').removeClass('menu-item--active');
              $('.menu-immagine').removeClass('menu-immagine--active');
              $(this).addClass('menu-item--active');
              $('.menu-item__submenu').slideUp();
              $(this).find('.menu-item__submenu').slideDown();
              $('.menu-immagine-' + number).addClass('menu-immagine--active');
              clearTimeout($(this).data('timeoutId'));
          }
      }
    }
    clicked = !clicked;
  });


}
else {
  $('.menu-item').hover(function() {
    var classes = $(this).attr('class').split(' ');
    var classNumber = classes.filter(function(c) {
      return c.indexOf('menu-item-') === 0;
    });
    if(classNumber.length > 0){
        var number = classNumber[0].match(/\d+/);
        if(number != null){
            number = number[0];
            $('.menu-item').removeClass('menu-item--active');
            $('.menu-immagine').removeClass('menu-immagine--active');
            $(this).addClass('menu-item--active');
            $('.menu-immagine-' + number).addClass('menu-immagine--active');
            clearTimeout($(this).data('timeoutId'));
        }
    }
  },
  function() {
    var $this = $(this);
    var classes = $(this).attr('class').split(' ');
    var classNumber = classes.filter(function(c) {
      return c.indexOf('menu-item-') === 0;
    });
    if(classNumber.length > 0){
        var number = classNumber[0].match(/\d+/);
        if(number != null){
            number = number[0];
            var $image = $('.menu-immagine-' + number);
            $this.data('timeoutId', setTimeout(function() {
              $this.removeClass('menu-item--active');
              $image.removeClass('menu-immagine--active');
            }, 100));
        }
    }
  });

}

    


  

  // $('.trigger').hover(function() {
  //   var classes = $(this).attr('class').split(' ');
  //   var number = classes.filter(function(c) {
  //     return c.indexOf('trigger-') === 0;
  //   })[0].match(/\d+/)[0];
  //   $('.trigger').removeClass('trigger--active');
  //   $('.immagine').removeClass('active');
  //   $(this).addClass('trigger--active');
  //   $('.immagine-' + number).addClass('active');

  //   var $this = $(this);
  //   var $image = $('.immagine-' + number);
  //   clearTimeout($this.data('timeoutId'));
  //   $this.data('timeoutId', setTimeout(function() {
  //     $this.removeClass('trigger--active');
  //     $image.removeClass('active');
  //   }, 1000));
  // }, function() {
  //   clearTimeout($(this).data('timeoutId'));
  // });
  



  // Header follow
  // $(window).scroll(function() {
  //   var scroll = $(window).scrollTop();

  //   if (scroll >= $(window).height()) {
  //     header.addClass("active-scroll");
  //   } else {
  //     header.removeClass("active-scroll");
  //   }

  //   if (scroll >= 300) {
  //     header.addClass("header-v1--transparent");
  //   } else {
  //     header.removeClass("header-v1--transparent");
  //   }
  // });

})(jQuery);



